import axios from '@axios'

export default {
  findByTipoFaixaAndPeriodo(tipoFaixaId, periodoId) {
    return axios.get('/financeiro/valor_faixas/buscar', { params: { tipoFaixaId, periodoVigenciaId: periodoId } });
  },
  save(data) {
    return axios.post('/financeiro/valor_faixas', data)
  },
  gerarMensalidadesLote(tipoFaixaId, periodoId) {
    return axios.post(`/financeiro/comandos/gerar-mensalidades-lote?tipoFaixaId=${tipoFaixaId}&periodoId=${periodoId}`)
  },
  corrigirValoresLote(tipoFaixaId, periodoId) {
    return axios.post(`/financeiro/comandos/corrigir-valores-lote?tipoFaixaId=${tipoFaixaId}&periodoId=${periodoId}`)
  },
}
